const baseMaps = [
	{
		'label':'3D Mode',
		'thumbnail':'layer_3d.png',  
		'onClick':(e)=>{}
	},
	{
		'label': 'Street Map',
		'value': 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
		'thumbnail':'layer_street.png'
	},
	{
		'label': 'Satellite',
		'value': 'mapbox://styles/espenvindr/cljo8k4sr00kb01qyam5bg89l',
		'thumbnail':'layer_satelite.png'
	},
	{	
		'label': 'Norway',
		'value': 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
		'layer': {
			'id': "kartverket",
			'source' : { 
				'id': "kartverket",
				'type': "raster", 
				'tiles': [ 
					"https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png"
				], 
				'tileSize': 256 
			}, 
			'layer':{ 
				'id': "kartverket-layer", 
				'type': "raster", 
				'source': "kartverket", 
				'paint': {} 
			}
		},
		'thumbnail':'layer_norway.png',
		'country':'Norway'
	},
	{
		'label': 'Estonia',
		'value': 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
		'layer': { 
			'id': "hallkaart",
			'source' : { 
				'id': "hallkaart",
				'type': "raster", 
				'tiles': [ 
					"https://tiles.maaamet.ee/tm/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=hallkaart&STYLE=default&FORMAT=image/png&TILEMATRIXSET=GMC&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}", 
				], 
				'tileSize': 256 
			}, 
			'layer':{ 
				'id': "hallkaart-layer", 
				'type': "raster", 
				'source': "hallkaart", 
				'paint': {} 
			}
		},
		'thumbnail':'layer_estonia.png',
		'country':'Estonia'
	},
	{	
		'label': 'Sweden',
		'value': 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
		'layer': {
			'id': "topowebbkartan",
			'source' : { 
				'id': "topowebbkartan",
				'type': "raster", 
				'tiles': [ 
					'https://vindrtech.com/mapproxy/service?layer=sweden_base_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
				], 
				
				'tileSize': 256 
			}, 
			'layer':{ 
				'id': "topowebbkartan-layer", 
				'type': "raster", 
				'source': "topowebbkartan", 
				'paint': {} 
			}
		},
		'thumbnail':'layer_sweden.png',
		'country':'Sweden'
	},

]




export { baseMaps };


